/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { CountryCode, parsePhoneNumberWithError } from "libphonenumber-js";
import { CountryCodeEnum } from "../enum/country-code.enum";

/**
 * Set the phone number and transform it to international format using libphonenumber
 * @param value the phone number
 * @returns the parsed phone number
 */
export function parsePhone(value: string, countryCode: CountryCodeEnum | undefined = CountryCodeEnum.germany) {
  if (!value) {
    return "";
  }

  try {
    // Parse the number with a default region (DE for Germany, change if needed)
    const parsedNumber = parsePhoneNumberWithError(value, countryCode as CountryCode);

    if (parsedNumber.isValid()) {
      // Format as international number
      return parsedNumber.format("INTERNATIONAL");
    } else {
      // If not valid, store original input
      return value;
    }
  } catch (error) {
    // If parsing fails, store original input
    return value;
  }
}
